import React, { useState } from "react";

function FoldingText({children, ...props}) {

    const [folded, setFolded] = useState('folded' in props ? props.folded : true);
    const foldedClass = folded ? ` ft-text--folded` : '';

    return (
        <div className={`ft-text${foldedClass}`}>
            <div className='ft-text__content'>
                {children}
            </div>
            <a
                className='ft-text__trigger'
                href='/'
                onClick={e => {
                    if (e) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                    setFolded(!folded)
                }}
            >
                {folded ? 'Show more' : 'Show less'}
            </a>
        </div>
    )
}

export default FoldingText